import * as React from 'react';
import Section from '../../components/Section';
import { Text, TextArea } from '../../components/forms';
import HelpHint from '../../components/HelpHint';
import { Company } from '../../company';

type Props = {
  company: Company;
  onChange: Function;
};

const setValue = (obj: any, onChange: Function) => (
  field: string,
  newValue: String,
) =>
  onChange(
    Object.assign({}, obj, {
      [field]: newValue,
    }),
  );

const withHttp = (url: string) =>
  !/^https?:\/\//i.test(url) ? `http://${url}` : url;

const setURLValue = (obj: any, onChange: Function) => (
  field: string,
  newValue: string,
) =>
  onChange(
    Object.assign({}, obj, {
      [field]: withHttp(newValue),
    }),
  );

export const BasicCompanyDetails = (props: Props) => (
  <React.Fragment>
    <Section title="Basic Details">
      <div className="flex flex-wrap">
        <div className="flex-auto w-70-l w-100 pr2">
          <Text
            label="Name"
            field={['name']}
            id="name"
            defaultValue={props.company.name}
            onValueChange={setValue(props.company, props.onChange)}
          />
          <Text
            label="Contact Email"
            field={['contact_email']}
            id="contact_email"
            defaultValue={props.company.contact_email}
            onValueChange={setValue(props.company, props.onChange)}
          />
          <Text
            label="Website URL"
            field={['public_url']}
            id="public_url"
            defaultValue={props.company.public_url}
            onValueChange={setURLValue(props.company, props.onChange)}
          />
          <TextArea
            label="Company Description"
            field={['description_text']}
            id="description_text"
            defaultValue={props.company.description_text}
            onValueChange={setValue(props.company, props.onChange)}
          />
        </div>
        <div className="flex-auto w-30-l w-100 pl2">
          <HelpHint>
            Note: Contact email address will be used for any new order
            notifications
          </HelpHint>
        </div>
      </div>
    </Section>
  </React.Fragment>
);

export default BasicCompanyDetails;
